import React from 'react';
import { Card, Badge } from '@/components/ui';
import { useNavigate } from 'react-router-dom';
import { Droplets, Zap, Activity, PenTool, Receipt, ShieldAlert, ArrowRight } from 'lucide-react';
import { cn } from '@/utils/cn';

export function UtilityModulesGrid() {
  const navigate = useNavigate();

  const MODULES = [
    {
      id: 'water',
      title: 'Hệ thống Nước & Tưới tiêu',
      description: 'Giám sát trạm bơm, mạng lưới đường ống, van tự động và cảnh báo rò rỉ nước.',
      icon: <Droplets className="w-6 h-6" />,
      color: 'blue',
      path: '/utility/water',
      stats: '4 Trạm hoạt động',
      gradient: 'from-blue-500 to-cyan-500',
      bgLight: 'bg-blue-50',
      textDark: 'text-blue-700'
    },
    {
      id: 'electrical',
      title: 'Hệ thống Điện & Chiếu sáng',
      description: 'Quản lý tủ điện, lưới điện ngầm, hệ thống chiếu sáng cảnh quan và chống sét.',
      icon: <Zap className="w-6 h-6" />,
      color: 'amber',
      path: '/utility/electrical',
      stats: '12 Tủ điện',
      gradient: 'from-amber-400 to-orange-500',
      bgLight: 'bg-amber-50',
      textDark: 'text-amber-700'
    },
    {
      id: 'iot',
      title: 'Cảm biến & Tự động hóa',
      description: 'Kết nối IoT đo độ ẩm đất, nhiệt độ, chất lượng nước và điều khiển từ xa.',
      icon: <Activity className="w-6 h-6" />,
      color: 'indigo',
      path: '/utility/iot',
      stats: '45 Cảm biến',
      gradient: 'from-indigo-500 to-violet-500',
      bgLight: 'bg-indigo-50',
      textDark: 'text-indigo-700'
    },
    {
      id: 'maintenance',
      title: 'Bảo trì Hạ tầng',
      description: 'Lên lịch vệ sinh trạm bơm, kiểm tra cáp điện và thay thế thiết bị hao mòn.',
      icon: <PenTool className="w-6 h-6" />,
      color: 'emerald',
      path: '/utility/maintenance',
      stats: '5 Kế hoạch',
      gradient: 'from-emerald-400 to-teal-500',
      bgLight: 'bg-emerald-50',
      textDark: 'text-emerald-700'
    },
    {
      id: 'billing',
      title: 'Chỉ số & Thanh toán',
      description: 'Ghi nhận chỉ số công tơ, tính toán chi phí năng lượng và xuất bảng kê.',
      icon: <Receipt className="w-6 h-6" />,
      color: 'slate',
      path: '/utility/billing',
      stats: 'Chốt chỉ số 25/05',
      gradient: 'from-slate-500 to-gray-600',
      bgLight: 'bg-slate-100',
      textDark: 'text-slate-700'
    },
    {
      id: 'incidents',
      title: 'Sự cố Hạ tầng',
      description: 'Tiếp nhận báo cáo hỏng hóc, chập điện, vỡ ống nước và theo dõi xử lý.',
      icon: <ShieldAlert className="w-6 h-6" />,
      color: 'rose',
      path: '/utility/incidents',
      stats: '3 Đang xử lý',
      gradient: 'from-rose-500 to-red-600',
      bgLight: 'bg-rose-50',
      textDark: 'text-rose-700'
    }
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4 h-full">
      {MODULES.map((mod) => (
        <Card
          key={mod.id}
          onClick={() => navigate(mod.path)}
          className="group relative overflow-hidden bg-white border-2 border-slate-100 hover:border-cyan-200 shadow-sm hover:shadow-xl rounded-3xl p-6 cursor-pointer transition-all duration-300 hover:-translate-y-1 h-full flex flex-col"
        >
          <div className={cn("absolute top-0 right-0 w-32 h-32 bg-gradient-to-br opacity-5 rounded-bl-full transition-transform duration-500 group-hover:scale-110", mod.gradient)} />

          <div className="flex items-start justify-between mb-4">
            <div className={cn("w-14 h-14 rounded-2xl flex items-center justify-center shadow-inner transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3", mod.bgLight, mod.textDark)}>
              {mod.icon}
            </div>
            <Badge variant="custom" className={cn("bg-slate-50 text-slate-600 border border-slate-100 font-bold px-2.5 py-1 text-[10px]")}>
              {mod.stats}
            </Badge>
          </div>

          <h4 className="text-lg font-black text-slate-800 mb-2 group-hover:text-cyan-700 transition-colors">{mod.title}</h4>
          <p className="text-xs text-slate-500 leading-relaxed mb-6 line-clamp-2 min-h-[36px] flex-grow">
            {mod.description}
          </p>

          <div className="flex items-center text-sm font-bold text-cyan-600 opacity-0 group-hover:opacity-100 transform translate-y-2 group-hover:translate-y-0 transition-all duration-300 mt-auto">
            Truy cập ngay <ArrowRight className="w-4 h-4 ml-1.5" />
          </div>
        </Card>
      ))}
    </div>
  );
}
